import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    kwicData: [],
    displayCSV: false,
    displayAbout: false,
  },
  mutations: {
    setKwicData (state, data) {
      state.kwicData = data;
    },
    setDisplayCSV(state, value) {
      state.displayCSV = value;
    },
    setDisplayAbout(state, value) {
      state.displayAbout = value;
    }
  }
});